<template>
  <div class="emd-container__content">
    <emd-alert
      :autoclose="false"
      :title="title"
      :variant="variant"
      @cancel="$emit('cancel')"
    >
      <template slot="content">
        <p
          v-for="(message, index) in alert.messages"
          :key="index"
        >
          {{ message }}
        </p>
      </template>
    </emd-alert>
  </div>
</template>
<script>
import { EmdAlert } from 'emerald-vue/src/components'

export default {
  name: 'InviteAlert',
  components: {
    EmdAlert
  },

  props: {
    alert: Object
  },

  computed: {
    variant () {
      return this.alert.isError ? 'danger' : 'success'
    },
    title () {
      return this.alert.isError
        ? this.$t('alert.error-title')
        : this.$t('alert.success-title')
    }
  }
}
</script>
